import { ResponseTimeMetric } from 'lib-dashboard-types';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo } from 'react';

import { useQueueDashboardQueueContext } from '../../../queue/queueDashboardQueue.context';

import { QueueDashboardAverageResponseTimeMetric } from './components/average/averageResponseTimeMetric';
import { QueueDashboardSLAResponseTimeMetric } from './components/sla/slaResponseTimeMetric';

type QueueDashboardResponseTimeMetricProps = {
  metric?: ResponseTimeMetric;
} & PropsWithClassName;

export const QueueDashboardResponseTimeMetric = memo(
  function QueueDashboardResponseTimeMetric(
    props: QueueDashboardResponseTimeMetricProps,
  ): JSX.Element {
    const { queue } = useQueueDashboardQueueContext();

    const hasSLA = queue?.queue_thresholds?.sla_percentage;

    return hasSLA ? (
      <QueueDashboardSLAResponseTimeMetric {...props} />
    ) : (
      <QueueDashboardAverageResponseTimeMetric {...props} />
    );
  },
);
